// extracted by mini-css-extract-plugin
export default {"topLogo":"QuizHeader_topLogo__-55f+","closeIcon":"QuizHeader_closeIcon__P2aYN","steps":"QuizHeader_steps__QiSZg","activeStep":"QuizHeader_activeStep__y6C7c"};